// Runtime environment configuration
// This loads from window._env_ which is injected at container startup
// Falls back to process.env for local development

interface RuntimeEnv {
  STRAPI_URL?: string
  STRAPI_TOKEN?: string
  BUILD_ID?: string
}

declare global {
  interface Window {
    _env_?: RuntimeEnv
    dataLayer?: Array<Record<string, unknown>>
  }
}

const getEnvVar = (key: keyof RuntimeEnv): string | undefined => {
  // Try runtime config first (production)
  if (typeof window !== 'undefined' && window._env_?.[key]) {
    console.log(`✓ ${key} loaded from window._env_`)
    return window._env_[key]
  }
  
  // Fall back to process.env (development)
  if (process.env[key]) {
    console.log(`✓ ${key} loaded from process.env`)
    return process.env[key]
  }
  
  console.warn(`⚠ ${key} not found in window._env_ or process.env`)
  return undefined
}

export const config = {
  STRAPI_URL: getEnvVar('STRAPI_URL') || 'http://localhost:1337',
  STRAPI_TOKEN: getEnvVar('STRAPI_TOKEN') || '',
  BUILD_ID: getEnvVar('BUILD_ID') || 'dev',
} as const

// Debug logging
console.log('=== Environment Configuration ===')
console.log('window._env_:', typeof window !== 'undefined' ? window._env_ : 'N/A (SSR)')
console.log('Configuration loaded:', {
  STRAPI_URL: config.STRAPI_URL,
  STRAPI_TOKEN: config.STRAPI_TOKEN ? `${config.STRAPI_TOKEN.substring(0, 20)}...` : '(empty)',
  BUILD_ID: config.BUILD_ID,
  source: typeof window !== 'undefined' && window._env_ ? 'window._env_' : 'process.env'
})
console.log('=================================')

export default config
